export const iconFontAwesomeMusicVideoSoundcloud = (
	<i className="fa-solid fa-soundcloud"></i>
);
